import { CartContext } from "../CartContext";
import { Fragment, useContext } from "react";
import { getProductData } from "../productStore";
import classes from "./Cart/CartItem.module.css";

function CartProduct(props) {
  const cart = useContext(CartContext);
  const id = props.id;
  const quantity = props.quantity;
  const productData = getProductData(id);

  const deleteCartHandler = () => {
    cart.deleteFromCart(id);
  };
  return (
    <Fragment>
      <div className={classes.cart}>
        <h3>{productData.name}</h3>
        <p>{quantity} total</p>
      </div>

      <div className={classes.second}>
        <img src={productData.image} />
        <p className={classes.price}>
          N{(quantity * productData.price).toFixed(2)}
        </p>
      </div>
      <button className={classes.button} onClick={deleteCartHandler}>
        Remove
      </button>
      <hr />
    </Fragment>
  );
}

export default CartProduct;
